"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocalizedDistanceMessage = void 0;
var MILES_MULTIPLIER = 0.621371;
var KM_MULTIPLIER = 1;
var getLocalizedDistanceMessage = function (distanceInMeters, countryCode, translations) {
    var distanceFixed = getLocalizedDistance(distanceInMeters / 1000, countryCode);
    var unit = countryCode === 'us' ? translations.miles : translations.km;
    return distanceFixed + ' ' + unit;
};
exports.getLocalizedDistanceMessage = getLocalizedDistanceMessage;
var getLocalizedDistance = function (distanceInKm, countryCode) {
    var unitMultiplier = countryCode === 'us' ? MILES_MULTIPLIER : KM_MULTIPLIER;
    var distance = distanceInKm * unitMultiplier;
    return distance.toFixed(1);
};
//# sourceMappingURL=localized-distance.js.map